// Helpers to turn the monthly stat docs into pivot data.

import { MIN_YEAR, monthYearKey } from './periods';

const gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 });
export const fmtMoney = (n) => gbp.format(Number(n) || 0);
export const fmtInt = (n) => Math.round(Number(n) || 0).toLocaleString('en-GB');

// Reports only cover MIN_YEAR onwards (earlier data is sparse / pre-money).
// Filtering is always on the underlying calendar month, independent of basis.
const recentYear = (year) => Number(year) >= MIN_YEAR;

/** Sorted distinct calendar year strings present in the monthly stats (MIN_YEAR+). */
export function statYears(monthly) {
  const ys = new Set(Object.keys(monthly).map((k) => k.slice(0, 4)).filter(recentYear));
  return [...ys].sort();
}

/**
 * Build a { dimension-value × year } cross-tab from monthly docs.
 *  - dimension: 'byCountry' | 'byRegion' | 'byChannel'
 *  - get(metricsObj) => number   (the chosen measure / revenue basis)
 * Returns { rows:[{key,label}], cols:[{key,label}], value(rowKey,colKey) }.
 */
export function crossTabByYear(monthly, dimension, get, { rowLabels, basis = 'calendar' } = {}) {
  const data = {}; // { rowKey: { yearKey: number } }
  const years = new Set();
  Object.entries(monthly).forEach(([mk, docM]) => {
    if (!recentYear(mk.slice(0, 4))) return;
    const year = monthYearKey(mk, basis);
    years.add(year);
    const dim = docM[dimension] || {};
    Object.entries(dim).forEach(([rowKey, m]) => {
      const row = data[rowKey] || (data[rowKey] = {});
      row[year] = (row[year] || 0) + (Number(get(m)) || 0);
    });
  });
  const cols = [...years].sort().map((y) => ({ key: y, label: y }));
  const rows = Object.keys(data).map((k) => ({ key: k, label: rowLabels?.[k] || k }));
  const value = (rowKey, colKey) => data[rowKey]?.[colKey] || 0;
  return { rows, cols, value };
}
